import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Row, Col, Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputSelect from '../../commons/form/InputSelect'
import InputText from '../../commons/form/InputText'
import RepairshopModalPage from '../../../containers/masters/Repairshop/RepairshopModalPage'
import RepairshopUsersAddModalPage from '../../../containers/masters/Repairshop/RepairshopUsersAddModalPage'

class RepairshopMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        organizedUnitId: null,
        name: null,
        description: null
      },
      isUsers: false
    }
  }

  componentDidUpdate () {
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchRepairshopList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchRepairshopList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  search () {
    this.props.actions.fetchRepairshopList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  openModal (repairshop, type = 'openEditRepairshopModal') {
    if (repairshop == null) {
      this.props.actions.openRepairshopModal(repairshop)
      this.setState({ isUsers: false })
    } else if (type === 'openEditRepairshopModal') {
      this.props.actions.openEditRepairshopModal(repairshop)
      this.setState({ isUsers: false })
    } else {
      this.props.actions.openRepairshopUsersModal(repairshop.userRepairshop, repairshop.repairshopId)
      this.setState({ isUsers: true })
    }
  }

  handleorganizedUnitComboChange (organizedUnitId) {
    if (this.state.filter.organizedUnitId !== organizedUnitId) {
      this.setState({ filter: { ...this.state.filter, organizedUnitId } })
    }
  }

  handleNameChange (name) {
    if (this.state.filter.name !== name) {
      this.setState({ filter: { ...this.state.filter, name } })
    }
  }

  handleDescriptionChange (description) {
    if (this.state.filter.description !== description) {
      this.setState({ filter: { ...this.state.filter, description } })
    }
  }

  resetFilters () {
    this.props.initialize({})
    this.props.reset()
    this.setState({
      filter: {
        organizedUnitId: null,
        name: null,
        description: null
      }
    })
    this.props.actions.fetchRepairshopList({ pageSize: 10 })
  }

  render () {
    const {
      t, repairshopList, pagesCount, repairshopListCount, filter,
      combos: { organizedUnitsAllCombo },
      filter: { page },
      actions: { fetchRepairshopList, deleteRepairshop }
    } = this.props
    const tKey = 'MASTERS.REPAIR_SHOPS_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const userTooltip = (<Tooltip id="editTooltip">{t(`${tKey}USERS`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const hasFilters = (this.state.filter.organizedUnitId || this.state.filter.description || this.state.filter.name)
    return (
      <div className="admin-wrapper">
        {this.state.isUsers
          ? <RepairshopUsersAddModalPage/>
          : <RepairshopModalPage/>
        }
        <Row className="section-users-header">
          <Col sm={12}>
            <div className="header-panel">
              <h4>{t(`${tKey}REPAIR_SHOPS`)}</h4>
            </div>
          </Col>
        </Row>
        <Row>
          <div className="search-form">
            <span className="title-search"><i className="ico-search" /> {t(`${tKey}SEARCH_TITLE`)}</span>
            <Row>
              <Field
                name="filters.organizedUnitId"
                colSm={3}
                controlLabel={t(`${tKey}OU`)}
                placeholder={t(`${tKey}OU`)}
                component={InputSelect}
                valueKey="id"
                labelKey="value"
                options={organizedUnitsAllCombo}
                onInputChange={(value) => this.handleorganizedUnitComboChange(value)}
              />
              <Field
                name="filters.name"
                colSm={3}
                controlLabel={t(`${tKey}NAME`)}
                placeholder={t(`${tKey}NAME`)}
                component={InputText}
                onInputChange={(value) => this.handleNameChange(value)}
              />
              <Field
                name="filters.description"
                colSm={3}
                controlLabel={t(`${tKey}DESCRIPTION`)}
                placeholder={t(`${tKey}DESCRIPTION`)}
                component={InputText}
                onInputChange={(value) => this.handleDescriptionChange(value)}
              />
              <Col sm={3} className="btn-wrapper" >
                <Button
                  className={'btn-white btn-input2 btn-white search-button'}
                  style={{ width: '100%', marginTop: '23px' }}
                  onClick={() => this.search()}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button style={{ marginTop: '23px' }}
                  className={'btn-icon btn-input ' + (hasFilters ? 'btn-standard' : 'btn-cancel')}
                  onClick={() => {
                    this.resetFilters()
                  }}>
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </Col>
            </Row>
          </div>
        </Row>
        <Col sm={12} className="col-row  section-users-body">
          <Table className="editable-table" hover responsive>
            <thead>
              <tr>
                <th onClick={() => { this.changeOrder('organizedUnitId') }}>
                  {t(`${tKey}OU`)}
                  <i className={this.getSortIcon('organizedUnitId')} />
                </th>
                <th onClick={() => { this.changeOrder('name') }}>
                  {t(`${tKey}NAME`)}
                  <i className={this.getSortIcon('name')} />
                </th>
                <th onClick={() => { this.changeOrder('description') }}>
                  {t(`${tKey}DESCRIPTION`)}
                  <i className={this.getSortIcon('description')} />
                </th>
                <th style={{ width: '80px' }}>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
              </tr>
            </thead>
            <tbody>
              {repairshopList && repairshopList.map((repairshop, idx) => {
                return (
                  <tr key={idx} className={repairshop.isDeleted ? 'is-deleted' : ''}>
                    <td>{organizedUnitsAllCombo && organizedUnitsAllCombo.find(x => x.id === repairshop?.organizedUnitId) && organizedUnitsAllCombo.find(x => x.id === repairshop?.organizedUnitId).value}</td>
                    <td>{repairshop.name}</td>
                    <td>{repairshop.description}</td>
                    <td>
                      {!repairshop.isDeleted && (
                        <div className='flex row'>
                          <a onClick={() => this.openModal(repairshop, 'openEditRepairshopModal')}>
                            <OverlayTrigger placement="left" overlay={editTooltip}>
                              <i className="ico-edit-white" />
                            </OverlayTrigger>
                          </a>
                          <a onClick={() => this.openModal(repairshop, 'openRepairshopUsersModal')}>
                            <OverlayTrigger placement="left" overlay={userTooltip}>
                              <i className="ico-user" />
                            </OverlayTrigger>
                          </a>
                          <a onClick={() => deleteRepairshop(repairshop.repairshopId)}>
                            <OverlayTrigger placement="left" overlay={deleteTooltip}>
                              <i className="ico-trash" />
                            </OverlayTrigger>
                          </a>
                        </div>
                      )}
                    </td>
                  </tr>)
              })
              }
              {(repairshopList === null || repairshopList === undefined || repairshopList.length === 0) &&
            <tr>
              <td colSpan={10}><h2>{t(`${tKey}RESULTS_NOT_FOUND`)}</h2></td>
            </tr>}
              <tr className="button-table-wrapper">
                <td>
                  <Button
                    className="btn-editable-table btn-standard"
                    onClick={() => this.openModal(null, 'openEditRepairshopModal')}>
                  + {t(`${tKey}ADD`)}
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
          <div className="section-users-footer">
            <nav key={1} className="text-center">
              <IDocCarPagination
                id="btn_pag_sales"
                page={page}
                pagesCount={pagesCount}
                totalRows={repairshopListCount}
                onSelectAction={(value) => fetchRepairshopList({ ...filter, ...this.state.filter, page: value })}
              />
            </nav>
          </div>
        </Col>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listRepairshop'
})(RepairshopMaster)
